import React from 'react';
interface SectionHeadingProps {
  overline?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'light' | 'dark';
  size?: 'md' | 'lg';
  className?: string;
}
export function SectionHeading({
  overline,
  title,
  subtitle,
  align = 'center',
  tone = 'light',
  size = 'md',
  className = ''
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  const isDark = tone === 'dark';
  const titleSize = size === 'lg' ? 'text-[2.35rem] sm:text-5xl lg:text-[3.4rem]' : 'text-[2rem] sm:text-4xl lg:text-[3rem]';
  return <div className={`${isCenter ? 'mx-auto max-w-3xl text-center' : 'max-w-2xl text-left'} ${className}`} data-id="element-220" data-mp="d8v6r4zj5l6j">
      {overline ? <p className={`flex items-center gap-3 text-[11px] font-semibold uppercase tracking-overline ${isDark ? 'text-gold-200' : 'text-gold-600'} ${isCenter ? 'justify-center' : ''}`} data-id="element-221" data-mp="8aabzl31rtph">
          <span className={`h-px w-7 ${isDark ? 'bg-gold-400/50' : 'bg-gold-200'}`} aria-hidden="true" data-id="element-222" data-mp="3veqbcbm7sf2i" />
          {overline}
          <span className={`h-px w-7 ${isDark ? 'bg-gold-400/50' : 'bg-gold-200'}`} aria-hidden="true" data-id="element-223" data-mp="1dzhuk37c2fhq" />
        </p> : null}

      <h2 className={`mt-5 font-serif leading-[1.06] ${titleSize} ${isDark ? 'text-cream' : 'text-sage-800'}`} data-id="element-224" data-mp="1isualoxy5dyv">
        {title}
      </h2>

      {subtitle ? <p className={`mt-5 text-[15.5px] leading-relaxed sm:text-[17px] ${isDark ? 'text-sage-100' : 'text-ink-soft'} ${isCenter ? 'mx-auto max-w-2xl' : ''}`} data-id="element-225" data-mp="190y881otv1ou">
          {subtitle}
        </p> : null}
    </div>;
}